import { testimonials } from '@/mocks/home';

export default function TestimonialSection() {
  return (
    <section className="bg-background-200/50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <span className="text-xs font-bold text-accent-700 uppercase tracking-wider">
              吃瓜口碑
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
            吃瓜群众都说好
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实吃瓜用户的评价，看看大家怎么说
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`bg-background-50 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 ${
                idx >= 4 ? 'opacity-60 hover:opacity-100' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm w-4 h-4 flex items-center justify-center ${
                      i < t.rating
                        ? 'ri-star-fill text-secondary-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 line-clamp-4">
                {t.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-400">
                    资深吃瓜用户
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}